import React from 'react';
import { Image, Linking, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import type { FeedbackAttachment } from '@shared/feedbackAttachments';
import { formatFeedbackAttachmentSize } from '@shared/feedbackAttachments';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors';

export function SupportAttachmentList({ attachments }: { attachments?: FeedbackAttachment[] }) {
  const visible = attachments?.filter((file) => file.signed_url) ?? [];
  if (visible.length === 0) return null;
  return (
    <View style={styles.list}>
      {visible.map((file) => (
        <TouchableOpacity key={file.id} style={styles.item} onPress={() => void Linking.openURL(file.signed_url as string)}>
          {file.mime_type.startsWith('image/') ? <Image source={{ uri: file.signed_url as string }} style={styles.thumbnail} /> : <View style={styles.pdf}><Text style={styles.pdfText}>PDF</Text></View>}
          <View style={styles.info}>
            <Text numberOfLines={1} style={styles.name}>{file.original_filename}</Text>
            <Text style={styles.meta}>{formatFeedbackAttachmentSize(file.size_bytes)} · Abrir</Text>
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  list: { gap: spacing.xs, marginTop: spacing.xs },
  item: { flexDirection: 'row', alignItems: 'center', gap: spacing.sm, padding: spacing.xs, borderRadius: 8, borderWidth: 1, borderColor: ticketColors.ruleSoft, backgroundColor: '#FFFFFF' },
  thumbnail: { width: 44, height: 44, borderRadius: 6, backgroundColor: ticketColors.brandSoft },
  pdf: { width: 44, height: 44, borderRadius: 6, alignItems: 'center', justifyContent: 'center', backgroundColor: ticketColors.brandSoft },
  pdfText: { fontSize: 10, fontWeight: '800', color: ticketColors.brandInk },
  info: { flex: 1, minWidth: 0 },
  name: { fontSize: 13, fontWeight: '600', color: ticketColors.ink },
  meta: { fontSize: 11, color: ticketColors.ink3, marginTop: 2 },
});
